import { call, put, takeLatest } from 'redux-saga/effects';
import { getThirdPartyIntegrations, deleteIntegration } from 'api/ThirdPartyIntegrationsAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';

/**
 * fetchThirdPartyIntegrations
 * Saga for fetching third party integrations
 * @return { void }
 */
export function* fetchThirdPartyIntegrationsSaga() {
  try {
    const { data } = yield call(getThirdPartyIntegrations);
    yield put(actions.fetchThirdPartyIntegrationsResponse(data));
  } catch (error) {
    yield put(actions.fetchThirdPartyIntegrationsError(error));
    const message = 'Error fetching third party integrations. Please try again.';
    yield put(addNegativeToast(message));
  }
}

export function* removeThirdPartyIntegrationSaga({ integrationId, integrationName }) {
  try {
    yield call(deleteIntegration, integrationId);
    yield put(actions.removeIntegrationResponse(integrationId));
    yield put(addPositiveToast(`Integration with ${integrationName} was successfully deleted`));
  } catch (error) {
    yield put(actions.removeIntegrationError(error));
    const message = `Error deleting third party integration. Please try again.`;
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([
  takeLatest(actionTypes.FETCH_INTEGRATIONS_REQUEST, fetchThirdPartyIntegrationsSaga),
  takeLatest(actionTypes.REMOVE_INTEGRATION_REQUEST, removeThirdPartyIntegrationSaga),
]);
